/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    array, bool, func, object, string,
} from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Slider from './Slider';

const styles = (theme) => ({
    root: {
        maxWidth: '1400px',
        width: '96%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '15px 32px 40px',
        margin: 'auto',
        '@media screen and (max-width: 768px)': {
            padding: '15px 0 40px',
        },
        [theme.breakpoints.down(1140)]: {
            maxWidth: '90%',
        },
        [theme.breakpoints.down(768)]: {
            maxWidth: '600px',
        },
        [theme.breakpoints.down(560)]: {
            maxWidth: '350px',
        },
    },
    carouselHeader: {
        fontSize: '30px',
        fontFamily: 'Montserrat',
        fontWeight: 700,
        paddingBottom: '40px',
        textTransform: 'uppercase',
    },
});

const PassportCarousel = ({
    classes, product, selectVariant, productSkuPrices, dynamicPriceList, selectedVariant, displayDescription, trackEvent, variantsDetail,
}) =>  (
    <div className={classes.root}>
        <Slider
            product={product}
            trackEvent={trackEvent}
            selectVariant={selectVariant}
            variantsDetail={variantsDetail}
            selectedVariant={selectedVariant}
            productSkuPrices={productSkuPrices}
            dynamicPriceList={dynamicPriceList}
            displayDescription={displayDescription}
        />
    </div>
);

PassportCarousel.propTypes = {
    classes: object.isRequired,
    product: object.isRequired,
    productSkuPrices: array.isRequired,
    selectVariant: func.isRequired,
    dynamicPriceList: func.isRequired,
    selectedVariant: string.isRequired,
    displayDescription: bool.isRequired,
    trackEvent: func.isRequired,
    variantsDetail: object.isRequired,
};

export default withStyles(styles)(PassportCarousel);
